// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VoiceOrderForm_voice-order-form__wVdBo {
  flex-grow: 1;
}

.VoiceOrderForm_voice-order-form__inputs-wrapper__cbGET {
  padding: 4rem 2rem;
  border-radius: 1rem;
  border: 1px solid var(--black-ten-opacity);
  margin-bottom: 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.VoiceOrderForm_voice-order-form__record-wrapper__fCmzb {
  text-align: center;
  align-self: stretch;
}

.VoiceOrderForm_voice-order-form__record-status-text__B\\+dCM {
  color: #1d4eaf;
  font-size: var(--text-lg);
  font-weight: 500;
  margin-bottom: 2rem;
}

.VoiceOrderForm_voice-order-form__record-status-text--error__8w-ri {
  color: var(--danger);
}

.VoiceOrderForm_voice-order-form__elapsed-time__QtKKA {
  margin-top: 1.8rem;
  color: var(--black-light);
  font-size: var(--text-base);
  font-weight: 700;
}

.VoiceOrderForm_voice-order-form__audio-controls-wrapper__8imNY {
  flex-grow: 1;
  max-width: 80%;
  margin-inline: auto;
  display: flex;
  gap: 3rem;
  align-items: center;
}

.VoiceOrderForm_voice-order-form__audio-player__tesoE {
  flex-grow: 1;
}

.VoiceOrderForm_voice-order-form__delete-audio-btn__4\\+MVS {
  flex-shrink: 0;
}

.VoiceOrderForm_voice-order-form__audio-loading__W5bqn {
  margin-inline: auto;
  width: 8rem;
  height: 8rem;
}

.VoiceOrderForm_voice-order-form__image-loading__7Hylg {
  margin-inline: auto;
  width: 8rem;
  height: 8rem;
}

.VoiceOrderForm_voice-order-form__upload-image-btn__sdjcc {
  margin: 7.3rem auto 0;
  display: flex;
  flex-flow: row wrap;
  align-items: flex-end;
  gap: 4rem;
}

.VoiceOrderForm_voice-order-form__upload-image-btn__sdjcc:disabled,
.VoiceOrderForm_voice-order-form__upload-image-btn__sdjcc:disabled:hover {
  background-color: #fff;
}

.VoiceOrderForm_voice-order-form__camera-wrapper__l6TLv {
  width: 6rem;
  height: 6rem;
  border: 1px solid var(--primary-color-forty-opacity);
  border-radius: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.VoiceOrderForm_voice-order-form__camera-icon__ou4TL {
  width: 4rem;
  height: 4rem;
  object-fit: contain;
}

.VoiceOrderForm_voice-order-form__upload-image-text__2K2kT {
  padding-inline-end: 1rem;
  border-bottom: 1px solid var(--primary-color);
  color: var(--primary-color);
  font-size: var(--text-lg);
  font-weight: 500;
  margin-bottom: 0.8rem;
}

.VoiceOrderForm_voice-order-form__upload-image-rules__2XWg1 {
  text-align: end;
  color: var(--gray-extra-dark);
  font-size: var(--text-sm);
  font-weight: 500;
}

.VoiceOrderForm_voice-order-form__upload-image-error__XHd8- {
  margin-top: 2.5rem;
  text-align: center;
}

.VoiceOrderForm_voice-order-form__images-wrapper__NvR\\+K {
  align-self: stretch;
}

.VoiceOrderForm_voice-order-form__line__z2VfH {
  margin-top: 6rem;
  margin-bottom: 5rem;
  height: 0.1rem;
  background-color: var(--black-ten-opacity);
}

.VoiceOrderForm_voice-order-form__uploaded-images-wrapper__NeR7U {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  gap: 1.2rem;
}

.VoiceOrderForm_voice-order-form__uploaded-image-wrapper__YAOOV {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.VoiceOrderForm_voice-order-form__uploaded-image__7JB60 {
  width: 8rem;
  height: 8rem;
  border-radius: 0.8rem;
}

.VoiceOrderForm_voice-order-form__upload-another-image-btn__iHY9u {
  max-width: 8rem;
  border: 1px solid var(--black-ten-opacity);
  border-radius: 0.7rem;
  padding: 2rem;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  color: var(--primary-color);
  font-size: var(--text-sm);
  font-weight: 500;
}

.VoiceOrderForm_voice-order-form__upload-another-image-img__0zJjh {
  width: 2.8rem;
  height: 2.6rem;
}

.VoiceOrderForm_voice-order-form__submit-btn__ewnNF {
  padding: 1.2rem 4rem;
}

.VoiceOrderForm_voice-order-form__submit-wrapper__sh24b {
  width: max-content;
  margin-inline-start: auto;
}

.VoiceOrderForm_voice-order-form__submit-error__8ZGn- {
  margin-top: 1.5rem;
}

.VoiceOrderForm_voice-order-form__confirm-btn__Nak2m {
  margin-inline-start: auto;
  padding: 1rem 3rem;
}

.VoiceOrderForm_voice-order-form__confirm-loading__Mua4G {
  margin-inline: auto;
}

.VoiceOrderForm_voice-order-form__confirm-error__aLqKZ {
  text-align: center;
}

.VoiceOrderForm_voice-order-form__confirm-error-wrapper__SooAY {
  margin-top: 1.2rem;
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .VoiceOrderForm_voice-order-form__audio-controls-wrapper__8imNY {
    max-width: 100%;
    gap: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/VoiceOrder/VoiceOrderForm/VoiceOrderForm.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;AACX;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oDAAoD;EACpD,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;EAC7C,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,qBAAqB;EACrB,aAAa;EACb,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;AACF","sourcesContent":[".voice-order-form {\n  flex-grow: 1;\n}\n\n.voice-order-form__inputs-wrapper {\n  padding: 4rem 2rem;\n  border-radius: 1rem;\n  border: 1px solid var(--black-ten-opacity);\n  margin-bottom: 5rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.voice-order-form__record-wrapper {\n  text-align: center;\n  align-self: stretch;\n}\n\n.voice-order-form__record-status-text {\n  color: #1d4eaf;\n  font-size: var(--text-lg);\n  font-weight: 500;\n  margin-bottom: 2rem;\n}\n\n.voice-order-form__record-status-text--error {\n  color: var(--danger);\n}\n\n.voice-order-form__elapsed-time {\n  margin-top: 1.8rem;\n  color: var(--black-light);\n  font-size: var(--text-base);\n  font-weight: 700;\n}\n\n.voice-order-form__audio-controls-wrapper {\n  flex-grow: 1;\n  max-width: 80%;\n  margin-inline: auto;\n  display: flex;\n  gap: 3rem;\n  align-items: center;\n}\n\n.voice-order-form__audio-player {\n  flex-grow: 1;\n}\n\n.voice-order-form__delete-audio-btn {\n  flex-shrink: 0;\n}\n\n.voice-order-form__audio-loading {\n  margin-inline: auto;\n  width: 8rem;\n  height: 8rem;\n}\n\n.voice-order-form__image-loading {\n  margin-inline: auto;\n  width: 8rem;\n  height: 8rem;\n}\n\n.voice-order-form__upload-image-btn {\n  margin: 7.3rem auto 0;\n  display: flex;\n  flex-flow: row wrap;\n  align-items: flex-end;\n  gap: 4rem;\n}\n\n.voice-order-form__upload-image-btn:disabled,\n.voice-order-form__upload-image-btn:disabled:hover {\n  background-color: #fff;\n}\n\n.voice-order-form__camera-wrapper {\n  width: 6rem;\n  height: 6rem;\n  border: 1px solid var(--primary-color-forty-opacity);\n  border-radius: 0.8rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.voice-order-form__camera-icon {\n  width: 4rem;\n  height: 4rem;\n  object-fit: contain;\n}\n\n.voice-order-form__upload-image-text {\n  padding-inline-end: 1rem;\n  border-bottom: 1px solid var(--primary-color);\n  color: var(--primary-color);\n  font-size: var(--text-lg);\n  font-weight: 500;\n  margin-bottom: 0.8rem;\n}\n\n.voice-order-form__upload-image-rules {\n  text-align: end;\n  color: var(--gray-extra-dark);\n  font-size: var(--text-sm);\n  font-weight: 500;\n}\n\n.voice-order-form__upload-image-error {\n  margin-top: 2.5rem;\n  text-align: center;\n}\n\n.voice-order-form__images-wrapper {\n  align-self: stretch;\n}\n\n.voice-order-form__line {\n  margin-top: 6rem;\n  margin-bottom: 5rem;\n  height: 0.1rem;\n  background-color: var(--black-ten-opacity);\n}\n\n.voice-order-form__uploaded-images-wrapper {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: flex-start;\n  gap: 1.2rem;\n}\n\n.voice-order-form__uploaded-image-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.voice-order-form__uploaded-image {\n  width: 8rem;\n  height: 8rem;\n  border-radius: 0.8rem;\n}\n\n.voice-order-form__upload-another-image-btn {\n  max-width: 8rem;\n  border: 1px solid var(--black-ten-opacity);\n  border-radius: 0.7rem;\n  padding: 2rem;\n  display: flex;\n  gap: 0.5rem;\n  justify-content: center;\n  align-items: center;\n  color: var(--primary-color);\n  font-size: var(--text-sm);\n  font-weight: 500;\n}\n\n.voice-order-form__upload-another-image-img {\n  width: 2.8rem;\n  height: 2.6rem;\n}\n\n.voice-order-form__submit-btn {\n  padding: 1.2rem 4rem;\n}\n\n.voice-order-form__submit-wrapper {\n  width: max-content;\n  margin-inline-start: auto;\n}\n\n.voice-order-form__submit-error {\n  margin-top: 1.5rem;\n}\n\n.voice-order-form__confirm-btn {\n  margin-inline-start: auto;\n  padding: 1rem 3rem;\n}\n\n.voice-order-form__confirm-loading {\n  margin-inline: auto;\n}\n\n.voice-order-form__confirm-error {\n  text-align: center;\n}\n\n.voice-order-form__confirm-error-wrapper {\n  margin-top: 1.2rem;\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .voice-order-form__audio-controls-wrapper {\n    max-width: 100%;\n    gap: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"voice-order-form": `VoiceOrderForm_voice-order-form__wVdBo`,
	"voice-order-form__inputs-wrapper": `VoiceOrderForm_voice-order-form__inputs-wrapper__cbGET`,
	"voice-order-form__record-wrapper": `VoiceOrderForm_voice-order-form__record-wrapper__fCmzb`,
	"voice-order-form__record-status-text": `VoiceOrderForm_voice-order-form__record-status-text__B+dCM`,
	"voice-order-form__record-status-text--error": `VoiceOrderForm_voice-order-form__record-status-text--error__8w-ri`,
	"voice-order-form__elapsed-time": `VoiceOrderForm_voice-order-form__elapsed-time__QtKKA`,
	"voice-order-form__audio-controls-wrapper": `VoiceOrderForm_voice-order-form__audio-controls-wrapper__8imNY`,
	"voice-order-form__audio-player": `VoiceOrderForm_voice-order-form__audio-player__tesoE`,
	"voice-order-form__delete-audio-btn": `VoiceOrderForm_voice-order-form__delete-audio-btn__4+MVS`,
	"voice-order-form__audio-loading": `VoiceOrderForm_voice-order-form__audio-loading__W5bqn`,
	"voice-order-form__image-loading": `VoiceOrderForm_voice-order-form__image-loading__7Hylg`,
	"voice-order-form__upload-image-btn": `VoiceOrderForm_voice-order-form__upload-image-btn__sdjcc`,
	"voice-order-form__camera-wrapper": `VoiceOrderForm_voice-order-form__camera-wrapper__l6TLv`,
	"voice-order-form__camera-icon": `VoiceOrderForm_voice-order-form__camera-icon__ou4TL`,
	"voice-order-form__upload-image-text": `VoiceOrderForm_voice-order-form__upload-image-text__2K2kT`,
	"voice-order-form__upload-image-rules": `VoiceOrderForm_voice-order-form__upload-image-rules__2XWg1`,
	"voice-order-form__upload-image-error": `VoiceOrderForm_voice-order-form__upload-image-error__XHd8-`,
	"voice-order-form__images-wrapper": `VoiceOrderForm_voice-order-form__images-wrapper__NvR+K`,
	"voice-order-form__line": `VoiceOrderForm_voice-order-form__line__z2VfH`,
	"voice-order-form__uploaded-images-wrapper": `VoiceOrderForm_voice-order-form__uploaded-images-wrapper__NeR7U`,
	"voice-order-form__uploaded-image-wrapper": `VoiceOrderForm_voice-order-form__uploaded-image-wrapper__YAOOV`,
	"voice-order-form__uploaded-image": `VoiceOrderForm_voice-order-form__uploaded-image__7JB60`,
	"voice-order-form__upload-another-image-btn": `VoiceOrderForm_voice-order-form__upload-another-image-btn__iHY9u`,
	"voice-order-form__upload-another-image-img": `VoiceOrderForm_voice-order-form__upload-another-image-img__0zJjh`,
	"voice-order-form__submit-btn": `VoiceOrderForm_voice-order-form__submit-btn__ewnNF`,
	"voice-order-form__submit-wrapper": `VoiceOrderForm_voice-order-form__submit-wrapper__sh24b`,
	"voice-order-form__submit-error": `VoiceOrderForm_voice-order-form__submit-error__8ZGn-`,
	"voice-order-form__confirm-btn": `VoiceOrderForm_voice-order-form__confirm-btn__Nak2m`,
	"voice-order-form__confirm-loading": `VoiceOrderForm_voice-order-form__confirm-loading__Mua4G`,
	"voice-order-form__confirm-error": `VoiceOrderForm_voice-order-form__confirm-error__aLqKZ`,
	"voice-order-form__confirm-error-wrapper": `VoiceOrderForm_voice-order-form__confirm-error-wrapper__SooAY`
};
export default ___CSS_LOADER_EXPORT___;
